@if (value) {
  <div class="notification-container">
    <div class="notification" [ngClass]="getSeverityAsString(severity) | lowercase">
      <label [innerHTML]="value | iconReplace"></label>
    </div>
  </div>
}
